export type ResponseError = Error & {
	response: Response;
};

export function getRedirectUrlFromShadowItError(error: ResponseError) {
	const errorResponse = error.message?.trim();

	// different browsers may have different error shapes
	const errorBody = errorResponse.startsWith('Forbidden')
		? // Firefox, eg.'Forbidden {"redirectUrl":"https://some-url.com"}'
			errorResponse.substring(9).trim()
		: // Chrome and others, eg.'{"redirectUrl":"https://some-url.com"}'
			errorResponse;

	try {
		// extract redirect url from error body
		return JSON.parse(errorBody)?.redirectUrl as string;
	} catch (err) {
		console.warn('Shadow IT redirectUrl is not valid JSON');
		return '';
	}
}
